export default {
  SET_TRANSPORT(state, data) {
    state.transport = data
  },
  SET_TRANSPORT_CATEGORY(state, data) {
    state.transport_category = data
  },
}
